import {
  PaginationRenderItemParams,
  Pagination as PaginationBase,
  PaginationItem,
  PaginationProps
} from "@mui/material";

const PreviousButton = () => <>&laquo; Previous</>;
const NextButton = () => <>Next &raquo;</>;

const PageItem = (item: PaginationRenderItemParams) => {
  return (
    <PaginationItem
      slots={{
        previous: PreviousButton,
        next: NextButton
      }}
      {...item}
    />
  );
};

function Pagination(props: Partial<PaginationProps>) {
  return (
    <PaginationBase
      shape="rounded"
      color="primary"
      renderItem={PageItem}
      {...props}
    />
  );
}

export default Pagination;
